import { Grid } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';

import { useFormContextPlus } from '../../../../../../../../form-plus/use-form-context-plus';
import { LabeledInput } from '../../../../../../../../locked-inputs';
import { TabPanelSectionProps } from '../../../../../../..';
import { ControlWrapper } from '../../../../../../../components/control-wrapper';
import { ServiceContractsFormValue } from '../../../../../types';

export const Note: React.FC<TabPanelSectionProps> = () => {
  const { t } = useTranslation();

  const { register } = useFormContextPlus<ServiceContractsFormValue>();

  return (
    <Collapse title={t('MASK.DESCRIPTION')} defaultOpen={true}>
      <Grid container spacing="1rem">
        <Grid item xs={12}>
          <ControlWrapper>
            <LabeledInput
              label={t('COMMON.NOTE')}
              {...register('note')}
              multiline={true}
              minRows={10}
              maxRows={10}
              style={{
                flex: 1,
                minHeight: '7rem',
              }}
            />
          </ControlWrapper>
        </Grid>
      </Grid>
    </Collapse>
  );
};
